import { AnyAction } from 'redux';
import { RsActions } from '../rsActions';

export const oeffentlichenDienstReducer = function (
  sectionState: boolean = null,
  action: AnyAction,
): boolean {
  switch (action.type) {
    case RsActions.OEFFENTLICHER_DIENST_CHANGED: {
      return action.payload;
    }
    default:
      return sectionState;
  }
};
